<section class="w-full flex flex-wrap md:flex-nowrap row-gap-2 p-3 border-bottom-1 border-bluegray-300">
  <p
    class="flex-none flex align-items-center w-12rem text-gray-500 font-normal text-sm"
  >
    Wybierz abonament (opcjonalnie)
  </p>
  <div
    class="flex-grow-1 flex flex-wrap align-items-center gap-2"
    [ngStyle]="{ 'min-height': '32px' }"
  >
    <ng-container *ngIf="oskSubscriptionPlans | async">
      <app-subscription-tag
        *ngFor="let subscription of availableSubscriptionsList"
        [ngStyle]="{ opacity: subscription.availablePlans <= 0 ? '0.3' : '1' }"
        [bgColor]="subscription.availablePlans > 0 ? subscription.bgColor : 'grey'"
        [fgColor]="subscription.fgColor"
        [planName]="subscription.planName"
        [selectable]="subscription.availablePlans > 0"
        [available]="subscription.availablePlans.toString()"
        (onSelectEvent)="selectAvailableSubscription(subscription)"
      ></app-subscription-tag>
    </ng-container>
  </div>
</section>

<section>
  <p-table [value]="selectedSubscription()">
    <ng-template pTemplate="header">
      <tr class="transparent">
        <th class="text-gray-500 font-normal text-sm">Nazwa</th>
        <th class="text-gray-500 font-normal text-sm">Akcje</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-subscription let-rowIndex="rowIndex">
      <tr>
        <td>
          <app-subscription-tag
            [bgColor]="subscription.bgColor"
            [fgColor]="subscription.fgColor"
            [planName]="subscription.planName"
            [selectable]="false"
          ></app-subscription-tag>
        </td>

        <td>
          <p-button
            icon="pi pi-trash"
            [rounded]="true"
            [text]="true"
            (onClick)="
              this.selectedSubscription().length > 0
                ? removeSelectedSubscription(subscription.planGuid)
                : ''
            "
            data-clarity-unmask="true"
          ></p-button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="12" class="text-gray-500 font-normal text-sm">
          Nie wybrano żadnego abonamentu
        </td>
      </tr>
    </ng-template>
  </p-table>
</section>

<p class="error-message mt-2 pl-3">{{ missingSubscriptionMessage() }}</p>
